module.exports = __webpack_public_path__ + "img/settings_active.e1179dd6.svg";